import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';

interface Props {
  icon: React.ReactNode;
  label: string;
  value: string;
}

function SpecificationBadge({ icon, label, value }: Props) {
  return (
    <Component>
      <IconContainer>{icon}</IconContainer>
      <Text>
        <Label>{label}</Label>
        <Value>{value}</Value>
      </Text>
    </Component>
  );
}

export default SpecificationBadge;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

const Label = styled.span`
  font-weight: 300;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.black};
`;

const Value = styled.span`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.black100};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;

  svg {
    max-width: 100%;
  }

  @media (max-width: 1400px) {
    flex: 0 0 40px;
    width: 40px;
  }
`;

const Component = styled.div`
  display: flex;
  align-items: center;

  ${media.mobile(css`
    ${Text} {
      flex: 1;
      width: 100%;
    }

    ${Label} {
      width: 100%;
    }

    ${Value} {
      width: 100%;
      font-size: 16px;
    }
  `)}
`;
